module.exports = __webpack_public_path__ + "static/media/deposit.0c41e809.jpg";